// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".border-radius[data-v-15c4c57a]{border-radius:5px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
